// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"SearchModal_modalWrapper__2bLY_","modal":"SearchModal_modal___Sx-D"};